export const enum MachineryFieldType {
    Text = 0,
    Number = 1,
    Date = 2,
}

export const enum MachineryRentalInvoicingMode {
    Manual = 0,
    Periodic = 1,
}

export const enum MachineryRentalFrequency {
    Daily = 0,
    Weekly = 1,
    Monthly = 2,
}
